module.exports = __webpack_public_path__ + "14ce2f57a234011ff97deb368c8417a9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/sofas/sofa-skate.png
// module id = 1631
// module chunks = 0